import { render, staticRenderFns } from "./purchaseOvertakeList.vue?vue&type=template&id=3918523c"
import script from "./purchaseOvertakeList.vue?vue&type=script&lang=js"
export * from "./purchaseOvertakeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports